import { format, isValid, subDays } from 'date-fns';
import { Functions as CommonFunctions } from 'fmc-digital-common';
import { round } from 'lodash';
const toUSD = input => {
  if ((input || input === 0) && !isNaN(Number(input))) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(Math.abs(Number(input)));
  }
  return '';
};
export const useSafeParseDateFormat = date => {
  if (!date || !isValid(new Date(date))) return '';
  const inputDate = new Date(date);
  return format(inputDate, 'MM/dd/yyyy');
};
const dateFormater = date => {
  const [recievedDate, ...rest] = date.toLowerCase().split(':');
  const recievedTime = `${rest?.join(':')} EST`;
  if (recievedDate === format(new Date(), 'MM-dd-yyyy')) return recievedTime;
  if (recievedDate === format(subDays(new Date(), 1), 'MM-dd-yyyy')) return 'Yesterday';
  const newDate = recievedDate.split('-');
  const formatedDate = format(new Date(`${newDate[2]}-${newDate[0]}-${newDate[1]}`), 'MMM dd, ');
  return formatedDate + recievedTime;
};
const truncateText = (str, limit) => {
  return str.length > limit ? str.substring(0, limit) + '...' : str;
};
const checkIfFileTypeInvalid = fileName => {
  const validType = ['PDF', 'JPEG', 'JPG', 'PNG'];
  return !validType.includes(CommonFunctions.getFileType(fileName));
};
const getIconName = fileExtension => {
  switch (fileExtension) {
    case 'pdf':
      return 'file-present';
    case 'png':
    case 'jpg':
    case 'jpeg':
      return 'image';
    default:
      return 'image';
  }
};
const validateFiles = newFiles => {
  const errors = [];
  const fileInfo = [];
  if (newFiles && newFiles.length) {
    for (var i = 0; i < newFiles.length; i++) {
      if (newFiles[i]) {
        const size = newFiles[i].size / 1000000;
        if (size > 8) {
          errors.push({
            errorType: 'FileSize',
            fileSize: `${round(size, 2)}`,
            fileName: newFiles[i].name
          });
        } else if (Functions.checkIfFileTypeInvalid(newFiles[i].name)) {
          errors.push({
            errorType: 'FileFormat',
            fileName: newFiles[i].name
          });
        } else {
          fileInfo.push(newFiles[i]);
        }
      }
    }
  }
  return {
    fileInfo,
    errors
  };
};
const Functions = {
  toUSD,
  useSafeParseDateFormat,
  dateFormater,
  truncateText,
  checkIfFileTypeInvalid,
  getIconName,
  validateFiles
};
export default Functions;
//# sourceMappingURL=index.js.map